import { withStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { compose } from 'recompose'
import withErrorCatcher from '../../Common/withErrorCatcher'

const IconEmpty = () => {
    return <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M51.2999 9.90002V31.5M62.0999 20.7L40.4999 20.7M31.4999 20.7C31.4999 26.6647 26.6646 31.5 20.6999 31.5C14.7352 31.5 9.8999 26.6647 9.8999 20.7C9.8999 14.7353 14.7352 9.90002 20.6999 9.90002C26.6646 9.90002 31.4999 14.7353 31.4999 20.7ZM31.4999 51.3C31.4999 57.2647 26.6646 62.1 20.6999 62.1C14.7352 62.1 9.8999 57.2647 9.8999 51.3C9.8999 45.3353 14.7352 40.5 20.6999 40.5C26.6646 40.5 31.4999 45.3353 31.4999 51.3ZM62.0999 51.3C62.0999 57.2647 57.2646 62.1 51.2999 62.1C45.3352 62.1 40.4999 57.2647 40.4999 51.3C40.4999 45.3353 45.3352 40.5 51.2999 40.5C57.2646 40.5 62.0999 45.3353 62.0999 51.3Z" stroke="#6A6DF2" stroke-width="4.5" stroke-linecap="round"/>
    </svg>    
}

const styles = () => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingTop: 24,
        justifyContent: 'center',
    },
    title: {
        color: '#18181B',
        fontStyle: 'normal',
        fontFamily: 'Rubik',
        fontWeight: '600',
        lineHeight: '32px',
        fontStretch: 'normal',
        letterSpacing: 'normal',
        fontSize: 24,
        marginTop: 12,
        overflow: "hidden",
        textOverflow: "ellipsis",  
    },
    subTitle: {
        marginTop: 8,
        color: '#6B6F7A',
        fontStyle: 'normal',
        fontFamily: 'Rubik',
        fontWeight: '400',
        lineHeight: '12px',
        fontStretch: 'normal',
        letterSpacing: 'normal',
        fontSize: 10,
        overflow: "hidden",
        textOverflow: "ellipsis",  
    }
})

export const FeedEmpty = ({classes}) => {

    const [t] = useTranslation('feedToolbar')

    return <div className={classes.container}>
        <IconEmpty />
        <div className={classes.title}>{t("Nothing shared (for now)")}</div>
        <div className={classes.subTitle}>{t("No items have been shared. Lead the way and share something first!")}</div>
    </div>
}
export default compose(
    withStyles(styles),
    withErrorCatcher(),
)(FeedEmpty);